import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import StudentsPage from "@/pages/StudentsPage";
import StudentNewPage from "@/pages/StudentNewPage";
import StudentDetailPage from "@/pages/StudentDetailPage";
import StudentEditPage from "@/pages/StudentEditPage";
import CoachesPage from "@/pages/CoachesPage";
import CoachNewPage from "@/pages/CoachNewPage";
import CoachEditPage from "@/pages/CoachEditPage";
import AttendancePage from "@/pages/AttendancePage";
import ProfilePage from "@/pages/ProfilePage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-[#0A2540] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            {/* AppShell's boot effect resolves this to the last active page
                (or /dashboard) — no redirect here, so there's a single
                source of truth instead of two navigations racing. */}
            <Route
              path="/"
              element={
                <div className="flex items-center justify-center py-24">
                  <div className="w-8 h-8 border-2 border-[#0A2540] border-t-transparent rounded-full animate-spin" />
                </div>
              }
            />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/students/new" element={<StudentNewPage />} />
            <Route path="/students/:id" element={<StudentDetailPage />} />
            <Route
              path="/students/:id/edit"
              element={
                <AdminOnly>
                  <StudentEditPage />
                </AdminOnly>
              }
            />
            <Route
              path="/coaches"
              element={
                <AdminOnly>
                  <CoachesPage />
                </AdminOnly>
              }
            />
            <Route
              path="/coaches/new"
              element={
                <AdminOnly>
                  <CoachNewPage />
                </AdminOnly>
              }
            />
            <Route
              path="/coaches/:id/edit"
              element={
                <AdminOnly>
                  <CoachEditPage />
                </AdminOnly>
              }
            />
            <Route path="/attendance" element={<AttendancePage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
